class CartSlider extends HTMLElement {
  constructor() {
    super();
    const cartSlider = this.querySelector('.cart-upsell-slider');    
    let cartUpsellSlider = new Swiper(cartSlider, {
      slidesPerView: 1,
      calculateHeight: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      spaceBetween: 2,  
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 2,
        },
        750: {
          slidesPerView: 1,
          spaceBetween: 2,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 2,
        },
      },
    });
  }

  connectedCallback() {    
    
  }  
}
customElements.define('cart-slider', CartSlider);


class CartCarousel extends HTMLElement {
  constructor() {
    super();
    const cartCarouselEle = this.querySelector(".cart__feature-slider");
    const cartCarousel = new Swiper(cartCarouselEle, {
      slidesPerView: 1,   
      loop: true,   
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },     
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      },
    });
  }
}
customElements.define('cart-carousel', CartCarousel);

document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper(".review-slider", {
    spaceBetween: 40,
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 7000,
        disableOnInteraction: false,
    },
    // freeMode: true,        
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },        
  });
  
  const thumbnailSlider = new Swiper(".product-thumbnail-slider", {
    slidesPerView: 5,
    spaceBetween: 10,
    autoHeight:true,
    watchSlidesProgress: true,
    direction: "vertical",
    navigation: {
      nextEl: ".thumbnail-button-next", 
      prevEl: ".thumbnail-button-prev", 
    },
      breakpoints: {
        0:{
          slidesPerView: 4,
            spaceBetween: 10,
        },
          1200: {
            slidesPerView:5,
            spaceBetween: 10,
          }
      }
    
  });
  
  const mainSlider = new Swiper(".main-product-slider", {
    slidesPerView: 1,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbnailSlider, // Link to the thumbnail slider
    },
  });

  // document.querySelector('.thumbnail-button-next').addEventListener('click', () => {
  //   mainSlider.slideNext();
  // });

  // document.querySelector('.thumbnail-button-prev').addEventListener('click', () => {
  //   mainSlider.slidePrev();
  // });
  
  
  // const mainSlider = new Swiper(".main-product-slider", {
  //     slidesPerView: 1,       
      
  //     pagination: {
  //         el: ".swiper-pagination",
  //         type: "fraction",
  //     },       
  //     navigation: {
  //         nextEl: ".swiper-button-next",
  //         prevEl: ".swiper-button-prev",
  //     },
  // });

  const iconTextSlider = new Swiper("#icon__text-slider", {
      slidesPerView: 1,    
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      }, 
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
  });
});

document.addEventListener('recommend-slider', () => {
  const paiEle = document.querySelector('.pair-products');
  
  let pairSlider = new Swiper(paiEle,
    {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
          delay: 7000,
          disableOnInteraction: false,
      },
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
      slidesPerView: 1.6,
      spaceBetween: 15,
      breakpoints: {
        1000: {
          slidesPerView: 2.6,
          spaceBetween: 15
        }
      }
    }
  );
});






// Change variant select options on cart drawer and cart page 
  let cartVariantUpdating = false;
  const textureReverseMap = {
    "Onctueuse": "onctueuse sans effet gras",
    "Légère": "légère sans effet de matière",
    "Gel crème": "gel crème",
    "Riche": "riche sans effet gras"
  };
  const fragranceReverseMap = {
    "Figuier": "Figuier",
    "Tiaré": "Tiaré",
    "Sans parfum": "Aucun parfum"
  };

  document.addEventListener("change", function(e){
    if(!e.target.classList.contains("cart-variant-option")) return;
    if(cartVariantUpdating) return;
    cartVariantUpdating = true;

    const container = e.target.closest(".cart-item");

    let currentItem = {};
      try {
        currentItem = JSON.parse(container.dataset.item || "{}");
      } catch (e) {
        console.warn("Invalid JSON in data-item", e);
      }
    let properties = { ...(currentItem.properties || {}) };
    
    // console.log(currentItem,"currentItem---");
    // console.log(properties,"currentItem.properties---");

    container.classList.add("variant-loading");
    const selects = container.querySelectorAll(".cart-variant-option");
    const options = [];
    selects.forEach(s => options.push(s.value));

    const variants = JSON.parse(e.target.dataset.variants);
    const line = e.target.dataset.line;
    const quantityInput = document.querySelector(`#Quantity-${line}`) || document.querySelector(`#Drawer-quantity-${line}`);
    const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

   const variant = variants.find(v =>
      v.options.every((opt,i)=> opt === options[i])
    );

    console.log(variant,"variant----");
    if(!variant) return;

    selects.forEach((select, index) => {
      const optionName = select.name.toLowerCase().trim();
      const selectedValue = variant.options?.[index];
      if (!selectedValue) return;

     if (optionName.includes("parfum") && properties.hasOwnProperty("fragrance")) {
        properties["fragrance"] =
          fragranceReverseMap[selectedValue] || selectedValue;
      }

      if (optionName.includes("texture") && properties.hasOwnProperty("texture")) {
        properties["texture"] =
          textureReverseMap[selectedValue] || selectedValue;
      }
    });


    const cartItems =  document.querySelector('cart-items') ||  document.querySelector('cart-drawer-items') || document.querySelector('#CartDrawer-CartItems');

    cartItems.enableLoading(line);

    /* remove current line */
    fetch(`${routes.cart_change_url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    })

    /* add new variant with SAME quantity */
    .then(()=>fetch(`${routes.cart_add_url}`,{
        method:"POST",
        headers:{ "Content-Type":"application/json"},
        body:JSON.stringify({
          id: variant.id,
          quantity: quantity,
          properties: properties
        })
    }))

    /* refresh cart sections like Dawn */
    .then(()=>fetch(`${routes.cart_url}?sections=main-cart-items,cart-icon-bubble,cart-drawer`))
    .then(res=>res.json())
    .then(sections=>{

      if(document.getElementById("main-cart-items")){
        document.querySelector("#main-cart-items .js-contents").innerHTML =
        new DOMParser()
        .parseFromString(sections["main-cart-items"],"text/html")
        .querySelector(".js-contents").innerHTML;
      }

      const cartBubble = document.getElementById("cart-icon-bubble");
      if(cartBubble){
        cartBubble.innerHTML =
        new DOMParser()
        .parseFromString(sections["cart-icon-bubble"],"text/html")
        .querySelector(".shopify-section").innerHTML;
      }

      const drawerItems = document.querySelector("#CartDrawer-CartItems");
      if(drawerItems){
        drawerItems.innerHTML =
        new DOMParser()
        .parseFromString(sections["cart-drawer"],"text/html")
        .querySelector("#CartDrawer-CartItems").innerHTML;
      }
    })
    .finally(()=>{
      cartItems.disableLoading(line);
      container.classList.remove("variant-loading");
      cartVariantUpdating = false;
    });
  });